// deps
import React, { ReactElement, useReducer, useState } from "react";

// contexts
import { GroupOrderCartContext, INITIAL_GROUP_ORDER_CONTEXT_VALUE } from "./GroupOrderCartContext";

// reducers
import { GroupCartReducer } from "@checkout-core/reducers/GroupCartReducer";

export function GroupOrderContextProvider(props: { children: React.ReactNode }): ReactElement {
    const [state, setState] = useReducer(GroupCartReducer, INITIAL_GROUP_ORDER_CONTEXT_VALUE.state);
    const [isGroupCartFlow, setIsGroupCartFlow] = useState<boolean>(INITIAL_GROUP_ORDER_CONTEXT_VALUE.isGroupCartFlow);

    const groupCartOrderContextValue = React.useMemo(
        () => ({
            state,
            setState,
            isGroupCartFlow,
            setIsGroupCartFlow,
        }),
        [isGroupCartFlow, state],
    );

    return (
        <GroupOrderCartContext.Provider value={groupCartOrderContextValue}>
            {props.children}
        </GroupOrderCartContext.Provider>
    );
}
